<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">조치처</th>
							<td class="col-2">
								<el-input v-model="input1" class="inputWithIcon" /><span class="unit input-icon"><i class="icon-sf-search" /></span>
							</td>
							<td class="col-6"><el-input v-model="input1" /></td>
							<th rowspan="3" class="col-1">확인</th>
							<th class="col-1">작성</th>
							<th class="col-1">승인</th>
						</tr>
						<tr>
							<th>참조처</th>
							<td>
								<el-input v-model="input1" class="inputWithIcon" /><span class="unit input-icon"><i class="icon-sf-search" /></span>
							</td>
							<td><el-input v-model="input1" /></td>
							<td><el-input v-model="input1" /></td>
							<td><el-input v-model="input1" /></td>
						</tr>
						<tr>
							<th>발신처</th>
							<td><el-input v-model="input1" /></td>
							<td><el-input v-model="input1" /></td>
							<td><el-input v-model="input1" /></td>
							<td><el-input v-model="input1" /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed
	},
	methods: {
		...rootMethods,
		change(value) {
			// this.setSearchParam_({ key: 'useYn', value: value });
			// this.$emit('search');
		},
		addAction() {},
		saveAction() {},
		deleteAction() {}
	}
};
</script>
